import { gql } from '@apollo/client';

export const UPDATE_ROTATIONSPLAN_VORLAGE = gql`
  mutation mitarbeiter_updateRotationsplanVorlage(
    $input: mitarbeiter_updateRotationsplanVorlageInput!
  ) {
    mitarbeiter_updateRotationsplanVorlage(
      updateRotationsplanVorlageInput: $input
    ) {
      success {
        rotationsplanVorlage {
          id
        }
      }
      error {
        __typename
        message
      }
    }
  }
`;
